export default {
  editor: {
    mention: {
      empty: 'Không tìm thấy ai',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Đăng nhập',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Mật khẩu',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Hiện mật khẩu',
    hidePassword: 'Ẩn mật khẩu',
    submit: 'Đăng nhập',
    or: 'hoặc',
    google: 'Đăng nhập bằng Google Workspace',
    footer: "Quyền truy cập do quản trị viên VINPROP cấp · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Email hoặc mật khẩu không đúng',
      unavailable: 'Dịch vụ đăng nhập không khả dụng. Thử lại sau một phút',
    },
  },
  nav: {
    myTasks: 'Việc của tôi',
    projects: 'Dự án',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    projectsOverline: 'Dự án',
    addProject: 'Thêm dự án',
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    projectSettings: 'Cài đặt dự án',
    collapse: 'Thu gọn menu',
    expand: 'Mở rộng menu',
    userMenu: 'Menu người dùng',
  },
  toolbar: {
    search: 'Tìm kiếm…',
    create: 'Tạo mới',
    view: {
      board: 'Bảng',
      list: 'Danh sách',
    },
    filters: {
      assignee: 'Người thực hiện',
      type: 'Loại',
      priority: 'Ưu tiên',
    },
  },
  views: {
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    myTasks: 'Việc của tôi',
    settings: 'Cài đặt dự án',
    soon: 'Màn hình sẽ có ở các task tiếp theo của epic.',
  },
  errors: {
    forbidden: {
      title: 'Không có quyền vào dự án',
      description: 'Dự án ở chế độ riêng tư. Hãy xin quyền từ quản trị viên dự án.',
    },
    notFound: {
      title: 'Không tìm thấy trang',
      description: 'Hãy kiểm tra địa chỉ: mục có thể đã đổi tên, công việc đã bị chuyển hoặc xoá.',
    },
    back: 'Về việc của tôi',
  },
}
